import { Box, Card, CircularProgress, Modal, Stack, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { FETCH_SITES_DESCRIPTIONS } from "../../constant/Apipath";
import { Postrequestcall } from "../../request/Postrequest";
import { Close as CloseIcon } from "@mui/icons-material";
import InfiniteScroll from "react-infinite-scroll-component";
import { useNavigate } from "react-router-dom";

export default function Sitedescriptions(props) {
  const { loginData, selectedSite } = useSelector((state) => state?.main);
  const [descriptions, setDescriptions] = useState([]);
  const [pageNo, setPageno] = useState(1);
  const [allDataLoaded, setAllDataLoaded] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (props.otherDescriptionDialogOpen === true) {
      getDescriptions(1);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.otherDescriptionDialogOpen]);

  const getDescriptions = async (pageNo) => {
    try {
      const getObj = {
        PageNr: pageNo,
        NrOfRecPerPage: 10,
        FullSearch: "",
        UserId: loginData?.userInformation?.UserId,
        IncludeRecordNr: "true",
        TypeOfObjectReturned: "",
        FetchAllowedRecordsOnly: true,
        DoNotSearchInSystemFields: true,
        SearchList: [{ siteId: selectedSite?.id }],
        SortList: [
          {
            FieldName: "Id",
            Direction: "DESC"
          }
        ]
      };
      let siteDescriptionsRes = await Postrequestcall(
        FETCH_SITES_DESCRIPTIONS,
        getObj,
        loginData?.accessToken
      );
      if (siteDescriptionsRes.status === 200) {
        if (pageNo > 1) {
          setTimeout(() => {
            setDescriptions((prevDescription) => [
              ...prevDescription,
              ...siteDescriptionsRes?.data?.data
            ]);
          }, 500);
        } else {
          setDescriptions(siteDescriptionsRes?.data?.data);
        }
        if (siteDescriptionsRes?.data?.data?.length === 0) {
          setAllDataLoaded(true);
        }
        if (siteDescriptionsRes?.data?.data?.length < 10) {
          setAllDataLoaded(true);
        } else {
          setAllDataLoaded(false);
        }
        setPageno(pageNo + 1);
      }
    } catch (error) {
      console.log("getDescriptions-> Error While Getting Site Description: ", error);
    } finally {
    }
  };

  // Navigate to profile
  const onNavigateProfile = (e, item) => {
    navigate(`/${item?.createdBy}`);
  };

  return (
    <Modal open={props.otherDescriptionDialogOpen} onClose={props.handleClose}>
      <Box className="user-modal-responsive">
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between"
          }}>
          <Typography className="add-title">{selectedSite?.name}</Typography>
          <Stack flexDirection={"row"} gap={1} alignItems={"center"}>
            <CloseIcon
              style={{ color: "#083DB8", cursor: "pointer" }}
              onClick={props.handleClose}
            />
          </Stack>
        </Box>
        <div
          id="scrollablediv_description"
          style={{ height: 300, overflow: "auto", position: "relative", scrollbarWidth: "none" }}>
          <InfiniteScroll
            dataLength={descriptions?.length}
            next={() => getDescriptions(pageNo)}
            hasMore={!allDataLoaded}
            loader={
              allDataLoaded ? null : (
                <h4 style={{ display: "flex", justifyContent: "center" }}>
                  <CircularProgress />
                </h4>
              )
            }
            scrollableTarget="scrollablediv_description">
            {descriptions.map((item, index) => (
              <Card
                className="pagelist-content site-description"
                style={{
                  marginBottom: "10px",
                  marginTop: "0px",
                  padding: "10px"
                }}>
                <Stack>
                  <Stack
                    display={"flex"}
                    flexDirection={"row"}
                    alignItems={"center"}
                    style={{ cursor: "pointer" }}
                    gap={1}
                    onClick={(e) => onNavigateProfile(e, item)}>
                    <img alt="Description" className="des-img" src={item?.pictureUrl}></img>
                    <Typography className="author-name">{item?.authorName}</Typography>
                  </Stack>
                  <Typography
                    sx={{
                      width: "100%",
                      overflow: "hidden",
                      wordBreak: "break-all",
                      whiteSpace: "normal"
                    }}>
                    {item?.description &&
                      item?.description.split("\n").map((line, idx) => (
                        <div key={idx} style={{ wordBreak: "break-all" }}>
                          {line}
                          <br />
                        </div>
                      ))}
                  </Typography>
                </Stack>
              </Card>
            ))}
          </InfiniteScroll>
        </div>
      </Box>
    </Modal>
  );
}
